export default "__VITE_ASSET__780248f3__"